<template>
  <section>
    <router-link
        :to="{name: 'Damage'}">
      Back
    </router-link>
    <h3>Report Damage</h3>
    <b-field label="Disaster Name">
      <b-select placeholder="Select disaster" v-model="form.disasterCode">
        <option
            v-for="i in disasterNames"
            :key="i._id"
            :value="i.code">
          {{i.year}} - {{i.name}}
        </option>
      </b-select>
    </b-field>
    <b-field label="Disaster Type">
      <b-select placeholder="Select status" v-model="form.disasterType">
        <option value="EARTHQUAKE">
          Gempa Bumi
        </option>
        <option value="FIRE">
          Kebakaran
        </option>
        <option value="FLOOD">
          Banjir
        </option>
        <option value="LANDSLIDE">
          Longsor
        </option>
        <option value="TSUNAMI">
          Tsunami
        </option>
      </b-select>
    </b-field>
    <b-field label="Damage Level">
      <b-select placeholder="Select status" v-model="form.level">
        <option value="NORMAL">
          Normal
        </option>
        <option value="EMERGENCY">
          Emergency
        </option>
        <option value="ENORMOUS">
          Enormous
        </option>
      </b-select>
    </b-field>
    <b-field label="Name">
      <b-input v-model="form.name" placeholder="Report name"/>
    </b-field>
    <b-field label="Province">
      <b-select placeholder="Select status" v-model="form.province">
        <option value="JKT">
          Jakarta
        </option>
        <option value="BDG">
          Bandung
        </option>
        <option value="SULUT">
          Sulawesi Utara
        </option>
      </b-select>
    </b-field>

    <!-- earthquake data -->
    <section v-if="isEarthQuakeData">
      <b-field label="Kedalaman Gempa (Km)">
        <b-input v-model="form.earthquake.depth" placeholder="dalam Km"/>
      </b-field>
      <b-field label="Kekuatan Gempa (Richter)">
        <b-input v-model="form.earthquake.magnitude" placeholder="dalam magnitude richter"/>
      </b-field>
      <b-field label="Keterangan Gempa">
        <b-input v-model="form.earthquake.description" placeholder="data tambahan"/>
      </b-field>
    </section>
    <!-- end earthquake -->

    <b-field label="Contact Number">
      <b-input :value="currentUser.contact" readonly/>
    </b-field>
    <b-field label="Reporter">
      <b-input :value="currentUser.name" readonly/>
    </b-field>
    <b-field label="Time of Occurence">
      <b-datetimepicker
          v-model="form.time"
          rounded
          placeholder="Click to select..."
          icon="calendar-today">
      </b-datetimepicker>
    </b-field>

    <b-field label="Place of Occurance">
      <b-input v-model="form.locationName" placeholder="Location Name"/>
    </b-field>
    <b-field label="Location">
      <span>
        <b-input v-model="form.location" placeholder="Coordinate"/><br/>
        <b-button @click="showSelectLocation">
          <b-icon icon="map"/>
          Select from map
        </b-button>
      </span>
    </b-field>
    <b-field label="Cause">
      <b-input v-model="form.cause" placeholder="Possible Cause"/>
    </b-field>
    <h4>Human Casualties</h4>
    <b-field label="Dead">
      <b-input type="number" v-model="form.casualties.death" placeholder="0"/>
    </b-field>
    <b-field label="Missing">
      <b-input type="number" v-model="form.casualties.missing" placeholder="0"/>
    </b-field>
    <b-field label="Serious Injury">
      <b-input type="number" v-model="form.casualties.major" placeholder="0"/>
    </b-field>
    <b-field label="Minor Injury">
      <b-input type="number" v-model="form.casualties.minor" placeholder="0"/>
    </b-field>
    <b-button
    @click="submit">
      Save
    </b-button>
    <b-modal :active.sync="visibleMapModal"
             :width="640" scroll="keep">
      <SelectLocation
          :marker="marker"
          :center="map.center"
          :zoom="map.zoom"
          @selectLocation="setLocation"/>
    </b-modal>
  </section>
</template>

<style lang="scss" scoped>
  /deep/ .modal .modal-content {
    height: 90vh;
  }
</style>

<script>
import {latLng} from 'leaflet'
import {mapActions, mapGetters} from 'vuex'
import SelectLocation from "@/components/SelectLocation"

const DEFAULT_CENTER = latLng(-0.599094, 117.504444)
const EARTHQUAKE = 'EARTHQUAKE'

export default {
  name: 'CreateDisasterName',
  components: {
    SelectLocation
  },
  data () {
    return {
      form: {
        disasterCode: '',
        level: '',
        disasterType: EARTHQUAKE,
        name: '',
        province: '',
        contact: '',
        reporter: '',
        time: null,
        locationName: '',
        location: '',
        cause: '',
        casualties: {
          death: 0,
          missing: 0,
          major: 0,
          minor: 0
        },
        earthquake: {
          depth: 0,
          magnitude: 0,
          description: ''
        }
      },
      marker: null,
      visibleMapModal: false,
      map: {
        center: DEFAULT_CENTER,
        zoom: 5
      }
    }
  },
  created () {
    this.init()
  },
  computed: {
    ...mapGetters('DisasterName', {
      disasterNames: 'names'
    }),
    ...mapGetters(['currentUser']),
    isEarthQuakeData () {
      return this.form.disasterType === EARTHQUAKE
    }
  },
  methods: {
    ...mapActions('Damage',['create']),
    ...mapActions('DisasterName',{
      fetchDisasters: 'fetch'
    }),
    init () {
      this.fetchDisasters()
    },
    submit () {
      this.create({
        ...this.form,
        reporter: this.currentUser.name,
        contact: this.currentUser.contact
      })
        .then(() => {
          this.$router.replace({name: 'Damage'})
        })
        .catch(() => {
          alert('Create failed')
        })
    },
    showSelectLocation () {
      this.visibleMapModal = true
    },
    setLocation (loc) {
      this.form.location = loc.lat + ',' + loc.lng
      this.visibleMapModal = false
    }
  },
  watch: {
    'form.location': function (v) {
      this.marker = latLng(...v.split(','))
    },
    isEarthQuakeData (v) {
      if (v) return

      this.form.earthquake = {
        depth: 0,
        magnitude: 0,
        description: ''
      }
    }
  }
}
</script>
